import { apiGet } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import { objectToQuery } from 'helpers/Formatter';

export function getMaintenanceInsights(options) {
  let route = '/landlords/dashboard_maintenance_insights';
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    dispatch(loadingMaintenanceGraphData());
    if (options.insight_id && options.insight_id !== '') {
      dispatch(setMaintenanceGraphLevel(options.insight_id));
    }
    return apiGet(Auth.getApiUrl() + route)
      .done(response => {
        dispatch(receiveMaintenanceGraphData(response.data));
      })
      .catch(error => {
        console.error(error);
        dispatch(errorMaintenanceGraphData());
      });
  };
}

export function getUserMaintenanceTickets(userId, userName, options) {
  let route = `/landlords/users/${userId}/maintenance_tickets`;
  if (options) {
    route += objectToQuery(options);
  }

  return dispatch => {
    dispatch(loadingMaintenanceGraphData());
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(
            recieveUserMaintenanceTickets(
              response.maintenance_tickets.sort((a, b) => {
                return new Date(b.last_updated) - new Date(a.last_updated);
              }),
              userId,
              userName
            )
          );
        })
        .catch(error => {
          console.error(error);
          dispatch(errorMaintenanceGraphData());
        }),
    });
  };
}

export function setMaintenanceGraphLevel(graphLevel) {
  return {
    type: 'DASHBOARD_MAINTENANCE_INSIGHTS::SET_GRAPH_LEVEL',
    level: graphLevel,
  };
}

export function loadingMaintenanceGraphData() {
  return {
    type: 'DASHBOARD_MAINTENANCE_INSIGHTS::LOADING_GRAPH_DATA',
  };
}

export function errorMaintenanceGraphData() {
  return {
    type: 'DASHBOARD_MAINTENANCE_INSIGHTS::GRAPH_DATA_ERROR',
  };
}

export function receiveMaintenanceGraphData(data) {
  return {
    type: 'DASHBOARD_MAINTENANCE_INSIGHTS::RECEIVE_GRAPH_DATA',
    data,
  };
}

export function recieveUserMaintenanceTickets(data, userId, userName) {
  return {
    type: 'DASHBOARD_MAINTENANCE_INSIGHTS::RECEIVE_USER_TICKETS',
    data,
    userId,
    userName,
  };
}
